import React from "react";
import { FormGroup, ModalBody, ModalHeader, Input, Label, Button, Form } from "reactstrap";
import SimpleReactValidator from "simple-react-validator";
import { addTopic, updateTopic} from "../../../services/topicService";
import { notifyError, notifySuccess } from "../../../utils/utils";
import Loader from "../../../utils/Loader";

class AddExpertize extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            topic: "",
            alertModel: false,
            alertMessage: "",
            loading: false
        };

        this.validator = new SimpleReactValidator({
            locale: 'en', messages:{}, autoForceUpdate: this,
            validators:{ 
                topic: {
                    message: "Topic name contains only Alphabet, Numbers and Symbols ,-'[]()&",
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val,  /^[\w&.,'/\s/g\[\]()\-]+$/)
                    }
                }
            }, 
        });

        // /^[a-zA-Z0-9$&()-\[\]{}'\\|,.]*$/
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        if(!this.validator.allValid()){
            this.validator.showMessages();
            this.forceUpdate();
            return;
        }
        const data = { topic_name: this.state.topic};
        
        this.setState({ loading: true });
        if(this.props.isEditing) {
            updateTopic(this.state.id, data).then(res => this.handleResponse(res.data))
        } else {
            addTopic(data).then(res => this.handleResponse(res.data)); 
        }
    }

    handleResponse(data) {
        console.log(data);
        if(data.status) {
            notifySuccess(data.message);
            setTimeout(() => {
                this.props.toggle();
                this.props.reload();
            }, 1000);
        } else {
            this.setState({ loading: false });
            notifyError(data.message);
        }
    }

    componentDidMount(){
        if(this.props.isEditing){
            console.log(this.props.topic);
            this.setState({
                topic: this.props.topic.topic_name,
                id: this.props.topic.topic_id
            });
        }
    }

    render() {
        this.validator.purgeFields();

        const { topic } = this.state;

        return(

            <React.Fragment>
                {/* <div className="page-content">
                    <Container fluid> */}
                        <ModalHeader toggle={() => this.props.toggle()}> 
                            {this.props.isEditing ? "Edit" : "Add"} Topic
                        </ModalHeader>
                        <ModalBody>
                      
                            <Form onSubmit={this.handleSubmit} autoComplete="off">

                                <FormGroup>
                                    <Label>Topic</Label>
                                    <Input
                                        type="text"
                                        name="topic"
                                        value={topic}
                                        onInput={e => {
                                            console.log(e);
                                        }}
                                        onChange={e => {
                                            this.setState({
                                                topic: e.target.value
                                            });
                                        }}
                                    />
                                <span className="text-danger">  
                                {
                                //alpha_num_space| 
                                }
                                    {this.validator.message('topic name', topic, 'required|min:2|max:30|topic')}
                                </span>
                                </FormGroup>

                                <FormGroup className="pull-right">
                                {
                                    this.state.loading
                                        ?
                                        <Loader />
                                        // <Spinner style={{ width: '3rem', height: '3rem' }}  color="primary" />
                                        :
                                        <Button color="success" type="submit">Submit</Button> 
                                }
                                </FormGroup>
                            </Form>
                        </ModalBody>
                    {/* </Container>
                </div> */}
            </React.Fragment>
        )
    }
}

export default AddExpertize;